import image from '../../images/crest.svg';
import { WaitingRoomLoginModal } from '../generic/Modals';
import type { User } from '../model/types';
import * as style from './WaitingRoom.module.css';

export interface Props {
    title: string;
    subtitle: string;
    mainMessage: string;
    reopenMessage: string;
    lastUpdatedMessage: string;
    user: null | undefined | Readonly<User>;
    logout(): void;
}

export default function WaitingRoom({ title, subtitle, mainMessage, reopenMessage, lastUpdatedMessage, user, logout }: Props) {
    return (
        <>
            <img width="64" height="64" src={image} />
            <h1>{title}</h1>
            <p className={style.info}>{subtitle}</p>
            <h3>{mainMessage}</h3>
            <p className={style.info}>{reopenMessage}</p>

            <LoginSection user={user} logout={logout} />
            <p className={style.lastUpdated}>{lastUpdatedMessage}</p>
            <p className={style.small}>
                Hvis noe haster, ta kontakt med vårt kundesenter
                <br />
                Telefon: <a href="tel:22015000">22 01 50 00</a>
                <br />
                E-post:
                <a href="mailto:kundesenter@vinmonopolet.no">kundesenter@vinmonopolet.no</a>
            </p>
        </>
    );
}

export const bodyClass = style.waitingRoomPage;

function LoginSection({ user, logout }: { user: null | undefined | Readonly<User>; logout(): void }) {
    if (user)
        return (
            <p>
                Du er logget inn som {user.displayUid}.{' '}
                <button className="link" onClick={logout}>
                    Logg ut
                </button>
            </p>
        );

    return (
        <>
            <p>
                Hvis du er påmeldt lanseringen kan du{' '}
                <button className="link" onClick={WaitingRoomLoginModal.call}>
                    logge deg inn her
                </button>
                .
            </p>
        </>
    );
}
